import clsx from 'clsx';
import React__default, { useState } from 'react';
import { cssAccordion, cssAccordionTitle, cssHeader, cssSummary } from './index.css.js';

const Accordion = ({ blue, rtlText, className, children, ...listProps }) => (React__default.createElement("ul", { ...listProps, className: clsx('c-accordion', className, cssAccordion, {
        'c-accordion--left': rtlText,
        'c-accordion--blue': blue
    }) }, children));
const AccordionTab = ({ className, children, 
/** Accordion Options */
buttonStyle = true, labelText, labelIcon, openOnLoad, 
/** Modifier Styling options below */
resetMinHeight, resetMarginTop, contentPaddingTop, slim, gray, shortSummary, onStateChange, ...liProps }) => {
    const [open, setOpen] = useState(openOnLoad);
    const elemClassStr = clsx({
        'c-accordion__header': true,
        'c-accordion__header--snow': gray,
        'c-accordion__header--slim': slim,
        'c-accordion--active': open
    });
    const handleClick = () => {
        setOpen(!open);
        onStateChange?.(!open);
    };
    const title = React__default.createElement("div", { className: `c-accordion__title ${cssAccordionTitle}` }, labelText);
    return (React__default.createElement("li", { ...liProps, className: clsx(className, {
            'c-accordion__item': true,
            'c-accordion__item--resetMinHeight': resetMinHeight,
            'c-accordion__item--resetMarginTop': resetMarginTop
        }) },
        buttonStyle ? (React__default.createElement("button", { className: elemClassStr, onClick: handleClick },
            title,
            React__default.createElement("div", { className: 'c-accordion__icon' }, labelIcon || null))) : (React__default.createElement("div", { className: `${elemClassStr} ${cssHeader}` },
            title,
            React__default.createElement("div", { className: 'c-accordion__icon', onClick: handleClick }, labelIcon || null))),
        !!shortSummary && !open ? React__default.createElement("div", { className: `${cssSummary} c-accordion__summary` }, shortSummary) : undefined,
        React__default.createElement("div", { className: clsx({
                'c-accordion__content': true,
                'c-accordion__content--addPaddingTop': contentPaddingTop
            }) }, children)));
};

export { Accordion, AccordionTab };
//# sourceMappingURL=index.js.map
